import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import { MyDraggable as Draggable } from '../../components/Core';
import HoverBar from '../../components/HoverBar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col } from 'reactstrap';

import state from '../../state';

import GKEvent from '../../events';

import { inlineElements, generateStyle, setOverLay, l } from '../../functions';
import { ajaxUri } from '../../consts/index';
import Icon from '../../components/Icons';

import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
  };
}

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      GK_ONEPAGE_CHECKOUT: 0,
      EZCONF_SHOW_PH_NUMBER_DISPLAY: 0,
      EZCONF_SHOW_PH_NUMBER_REQUIRED: 0,
      SHOW_CHECKOUT_ORDER_NOTE: 0,
      EZSCONF_PRECHECK_OPTIONS: 0,
      EZCONF_SHOW_CREATE_ACCOUNT: 0,
      EZCONF_SHOW_NEWSLETTER: 0,
      EZSCONF_SET_CHECKBOXES_POSITION: 0,
      GK_PRICE_AFTER_TEXT: 0,
      GK_PAYMENT_TEXT: 0,
      SHOW_CHECKOUT_ORDER_NOTE_REQUIRE: 0,
      globalSettings: [
        'GK_ONEPAGE_CHECKOUT',
        'EZCONF_SHOW_PH_NUMBER_DISPLAY',
        'EZCONF_SHOW_PH_NUMBER_REQUIRED',
        'SHOW_CHECKOUT_ORDER_NOTE',
        'EZSCONF_PRECHECK_OPTIONS',
        'EZCONF_SHOW_CREATE_ACCOUNT',
        'EZCONF_SHOW_NEWSLETTER',
        'EZSCONF_SET_CHECKBOXES_POSITION',
        'GK_PRICE_AFTER_TEXT',
        'GK_PAYMENT_TEXT',
        'SHOW_CHECKOUT_ORDER_NOTE_REQUIRE',
      ],
    };

    GKEvent.addEventListener('updateState', (key, value) => {
      this.setState(
        {
          [key]: value,
        },
        () => {
          // console.log("Re-render form.js");
        }
      );
    });
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings) ||
      !isEqual(this.state, nextState)
    ) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    if (this.state.globalSettings.length) {
      for (const setting of this.state.globalSettings) {
        this._getSetting(setting);
      }
    }
  }

  _getSetting = (key) => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'getSetting',
        key: key,
      },
    })
      .then((result) => {
        this.setState({
          [key]: result.data,
        });
      })
      .catch((error) => {
        GKEvent.notification('error', 'Error.');
      });
  };

  _initSteps = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;
    const settings = this.props.settings || {};
    let textsettings = {};

    const datasSettings = payload.datas || {};

    const stepsSettings = payload['settings-' + this.props.currentDevice] || payload.settings || {};

    const stepsCss = {
      ...datasSettings,
      ...stepsSettings,
    };

    const {
      nextStepBackgroundColor,
      previousStepBackgroundColor,
      currentStepBackgroundColor,
      nextStepTextColor,
      previousStepTextColor,
      currentStepTextColor,
    } = stepsCss || {};

    const cssSettings = generateStyle(payload, 'container');
    const cssSettingsText = generateStyle(payload, 'text', 'body');
    // if (settings["Paragraph"]) {
    //   const setting = settings["Paragraph"];
    //   const fontFamily =
    //     settings["heading_font"] && settings["heading_font"].fontFamily;
    //   textsettings = {
    //     fontFamily: fontFamily,
    //     textSize: setting.size,
    //   };
    // }

    cssSettingsText.fontSize = cssSettingsText.fontSize * 0.75;

    return (
      <Container fluid={payload.fullContainer}>
        <Row>
          <Col xs={12} className='fullcol checkout-steps' style={cssSettingsText}>
            <div className='steapbar'>
              <div className='steps'>
                <ul role='tablist'>
                  <li className='first previous-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8',
                        color: previousStepTextColor ? previousStepTextColor : '#ffffff',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${
                            previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8'
                          }`,
                          borderTop: `22px solid ${
                            previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                      <span className='current-info audible'>current step:</span>
                      Cart
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${
                            previousStepBackgroundColor ? previousStepBackgroundColor : '#f042a8'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                  <li className='disabled current-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4',
                        color: currentStepTextColor ? currentStepTextColor : '#ffffff',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${
                            currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4'
                          }`,
                          borderTop: `22px solid ${
                            currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                      Customer information
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${
                            currentStepBackgroundColor ? currentStepBackgroundColor : '#4370a4'
                          }`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                  <li className='disabled next-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee',
                        color: nextStepTextColor ? nextStepTextColor : '#000000',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          borderTop: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                      Shipping method
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                  <li className='disabled last next-step'>
                    <a
                      href='#0'
                      style={{
                        backgroundColor: nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee',
                        color: nextStepTextColor ? nextStepTextColor : '#000000',
                        ...textsettings,
                      }}
                    >
                      <span
                        className='before'
                        style={{
                          borderBottom: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          borderTop: `22px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                      Payment method
                      <span
                        className='after'
                        style={{
                          borderLeft: `20px solid ${nextStepBackgroundColor ? nextStepBackgroundColor : '#eeeeee'}`,
                          ...textsettings,
                        }}
                      ></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  _initForm = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const cssSettings = generateStyle(payload, 'container');
    const cssSettingsText = generateStyle(payload, 'text', 'body');

    const buttonStyle = {};
    const appearanceSettings = this.props.settings || {};
    if (appearanceSettings['active_button_text_color']) {
      buttonStyle.color = appearanceSettings['active_button_text_color']?.color || '#fff';
    }
    if (appearanceSettings['active_button_color']) {
      buttonStyle.backgroundColor = appearanceSettings['active_button_color']?.bgColor || '#2f862d';
      buttonStyle.borderColor = appearanceSettings['active_button_color']?.bgColor || '#2f862d';
    }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className='fullcol' style={cssSettingsText}>
            <div className='checkoutmainform'>
              <div className='overlay'></div>
              {this._initSteps()}
              <div id='checkoutform'>
                <div id='opc_account_form'>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <h3 className='main-headings' style={cssSettingsText}>
                        Contact Information
                      </h3>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <div className='required form-group opc-input'>
                        <label>
                          Email address <sup>*</sup>
                        </label>
                        <input type='text' className='is_required validate form-control' />
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <h3 className='main-headings' style={cssSettingsText}>
                        Shipping address
                      </h3>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='required form-group opc-input'>
                        <label>
                          First name <sup>*</sup>
                        </label>
                        <input type='text' className='is_required validate form-control' />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='required form-group opc-input'>
                        <label>
                          Last name <sup>*</sup>
                        </label>
                        <input type='text' className='is_required validate form-control' />
                      </div>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <div className='required form-group opc-input'>
                        <label>
                          Address <sup>*</sup>
                        </label>
                        <input type='text' className='form-control' />
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <div className='required form-group opc-input'>
                        <label>
                          City <sup>*</sup>
                        </label>
                        <input type='text' className='form-control' />
                      </div>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-md-4 col-xs-12'>
                      <div className='required select form-group opc-input opc-select inp-active'>
                        <label>
                          Country <sup>*</sup>
                        </label>
                        <select className='form-control'>
                          <option value='21'>United States</option>
                        </select>
                      </div>
                    </div>
                    <div className='col-md-4 col-xs-12 id_state select unvisible form-group opc-input inp-active'>
                      <label>
                        State <sup>*</sup>
                      </label>
                      <select className='form-control'>
                        <option value=''>-</option>
                      </select>
                    </div>
                    <div className='col-md-4 col-xs-12 nofloat'>
                      <div className='required postcode form-group opc-input'>
                        <label>
                          Zip/Postal Code <sup>*</sup>
                        </label>
                        <input className='validate form-control' />
                      </div>
                    </div>
                  </div>

                  {this.state.EZCONF_SHOW_PH_NUMBER_DISPLAY && (
                    <div className='row'>
                      <div className='col-md-12 col-xs-12'>
                        <div
                          className={`form-group opc-input ${
                            this.state.EZCONF_SHOW_PH_NUMBER_REQUIRED ? 'required' : ''
                          }`}
                        >
                          <label>
                            Mobile phone
                            {this.state.EZCONF_SHOW_PH_NUMBER_REQUIRED ? <sup>*</sup> : null}
                          </label>
                          <input type='text' className='form-control' />
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.SHOW_CHECKOUT_ORDER_NOTE ? (
                    <div className='row'>
                      <div className='col-md-12 col-xs-12'>
                        <div
                          className={`form-group opc-input order_comment_wrapper ${
                            this.state.SHOW_CHECKOUT_ORDER_NOTE_REQUIRE ? 'required' : ''
                          }`}
                        >
                          <label for='order_comment' id='order_comment_label'>
                            {l('Order comment')}
                            {this.state.SHOW_CHECKOUT_ORDER_NOTE_REQUIRE ? <sup>*</sup> : <></>}
                          </label>
                          <textarea
                            className='form-control'
                            name='order_comment'
                            id='order_comment'
                            rows='5'
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className='row'>
                    <div className='checkbox'>
                      <button className='btn btn-success' style={buttonStyle}>
                        Proceed
                      </button>
                    </div>
                  </div>
                  {this.state.EZCONF_SHOW_CREATE_ACCOUNT && (
                    <div className='row'>
                      <div className='checkbox'>
                        <label for='is_new_customer'>
                          <input
                            type='checkbox'
                            name='is_new_customer'
                            checked={this.state.EZSCONF_PRECHECK_OPTIONS ? true : false}
                            id='is_new_customer'
                            value='1'
                            autocomplete='off'
                          />
                          {l('Create an Account?')}
                        </label>
                      </div>
                    </div>
                  )}
                  {this.state.EZCONF_SHOW_NEWSLETTER && (
                    <div className='row'>
                      <div className='checkbox'>
                        <label for='newsletter'>
                          <input
                            type='checkbox'
                            name='newsletter'
                            id='newsletter'
                            checked={this.state.EZSCONF_PRECHECK_OPTIONS ? true : false}
                            value='1'
                          />
                          {l('Keep me up to date on news and exclusive offers')}
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                {parseInt(this.state.GK_ONEPAGE_CHECKOUT) === 1 && (
                  <div id='carrier_area'>
                    <div className='row carrier-listing '>
                      <div className='delivery_options_address col-md-12'>
                        <h3 className='carrier-heading main-headings' style={cssSettingsText}>
                          Please, choose a shipping method
                        </h3>
                        <div className='delivery_options'>
                          <div className='delivery_option'>
                            <div>
                              <table className='resume table'>
                                <tbody>
                                  <tr>
                                    <td className='delivery_option_radio'>
                                      <input id='delivery_option_0_0' className='delivery_option_radio' type='radio' />
                                    </td>
                                    <td className='delivery_option_logo'>
                                      <FontAwesomeIcon icon={['fad', 'truck']} />
                                    </td>
                                    <td>
                                      <span className='delivery_option_name'>Best shipper</span>
                                      <span className='delivery_option_desc'>Fast shipping</span>
                                    </td>
                                    <td className='delivery_option_price'>
                                      <div className='delivery_option_price'>Free</div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {parseInt(this.state.GK_ONEPAGE_CHECKOUT) === 1 && (
                  <div className='checkout_main payment-auth'>
                    <h3 className='page-heading bottom-indent ' style={cssSettingsText}>
                      Please choose your payment method
                    </h3>
                    <div className='paiement_block'>
                      <div id='HOOK_PAYMENT'>
                        <div id='stripe-bootstrap'>
                          <div className='row clearfix'>
                            <div id='stripe-cc-form' className='col-md-12 form-inline'>
                              <div id='stripe-card-wrapper' className='col-md-12 col-lg-12 col-xl-12 col-sm-12'>
                                <div className='jp-card-container'>
                                  <div className='jp-card'>
                                    <div className='jp-card-front'>
                                      <div className='jp-card-logo jp-card-elo'>
                                        <div className='e'>e</div>
                                        <div className='l'>l</div>
                                        <div className='o'>o</div>
                                      </div>
                                      <div className='jp-card-logo jp-card-visa'>visa</div>
                                      <div className='jp-card-logo jp-card-mastercard'>MasterCard</div>
                                      <div className='jp-card-logo jp-card-maestro'>Maestro</div>
                                      <div className='jp-card-logo jp-card-amex'></div>
                                      <div className='jp-card-logo jp-card-discover'>discover</div>
                                      <div className='jp-card-logo jp-card-dankort'>
                                        <div className='dk'>
                                          <div className='d'></div>
                                          <div className='k'></div>
                                        </div>
                                      </div>
                                      <div className='jp-card-lower'>
                                        <div className='jp-card-shiny'></div>
                                        <div className='jp-card-cvc jp-card-display'>•••</div>
                                        <div className='jp-card-number jp-card-display'>•••• •••• •••• ••••</div>
                                        <div className='jp-card-name jp-card-display'> </div>
                                        <div
                                          className='jp-card-expiry jp-card-display'
                                          data-before='month/year'
                                          data-after='valid thru'
                                        >
                                          ••/••
                                        </div>
                                      </div>
                                    </div>
                                    <div className='jp-card-back'>
                                      <div className='jp-card-bar'></div>
                                      <div className='jp-card-cvc jp-card-display'>•••</div>
                                      <div className='jp-card-shiny'></div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className='panel panel-default credit-card-box'>
                                <div className='panel-body'>
                                  <div className='row'>
                                    <div className='col-xs-12 col-md-12 form-group'>
                                      <div className='input-group'>
                                        <input
                                          className='form-control'
                                          id='stripeCardNumber'
                                          placeholder='Valid Card Number'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='row'>
                                    <div id='date-col' className='col-xs-6 col-md-6 col-lg-6 col-sm-6 form-group'>
                                      <input className='form-control' id='stripeCardExpiry' placeholder='MM / YY' />
                                    </div>
                                    <div id='cvc-col' className='col-xs-6 col-md-6 col-lg-6 col-sm-6 form-group'>
                                      <input className='form-control' id='stripeCardCVC' placeholder='CVC' />
                                    </div>
                                  </div>
                                  <div className='row'>
                                    <div className='col-xs-12 col-md-12'>
                                      <button
                                        className='submit subscribe btn btn-success btn-lg btn-block'
                                        id='add_payment_btn'
                                        style={buttonStyle}
                                      >
                                        Pay
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const { dropzoneID, parentID, showBasicContent, showPreview, id, dropzoneProps, payload, options, ...rest } =
      this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className='dragger'>
            {(Array.isArray(rest.icon) && <FontAwesomeIcon icon={rest.icon} />) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className='added'>{l('Added')}</span>) || (
              <span className='required'>{l('Required')}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initForm()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initForm()}
      </Draggable>
    );
  }
}

CheckoutForm.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(CheckoutForm);
